/*
 * AddQuestinarie Messages
 *
 * This contains all the text for the AddQuestinarie component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.AddQuestinarie';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  language: {
    id: `${scope}.language`,
    defaultMessage: 'Language',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
});
